module.exports = __webpack_public_path__ + "static/iosCheckPenaltiesAndGetProtocol-558b745585e122fbac6e86548b58153c.jpeg";